import { SentryLogger as Logger, RequestError } from "@ers/errors";

export const isStatusOK = ({ status, statusText }) =>
	statusText === "OK" || status === 200;
export function getJson({ data }) {
	if (typeof data === "string") {
		return JSON.parse(data);
	}
	return JSON.parse(JSON.stringify(data));
}
export function getString({ data }) {
	if (typeof data !== "string") {
		return data.toString();
	}
	return data;
}

function getNameFromHeaders(headers) {
	try {
		return headers["content-disposition"].split("filename=")[1].slice(1, -1);
	} catch (e) {
		return "file";
	}
}

export function getFileWithContent(response) {
	try {
		const fileName = getNameFromHeaders(response.headers);
		const contentType = response.headers["content-type"];
		const blob = new Blob([response.data], { type: contentType });
		return { blob, fileName };
	} catch (e) {
		return new Error(response.data.title);
	}
}

export const readError = ({ response }) => {
	try {
		const {
			config: { method, url },
			data,
			status,
		} = response;
		const html = document.createElement("html");
		html.innerHTML = data;
		return new RequestError({ url, response: { status, method, html } });
	} catch (error) {
		Logger.error(error);
		return null;
	}
};

export const isError = (data) =>
	data instanceof Error || data instanceof RequestError;
export const validStatuses = [200, 204, 304, 404];
export const isValidStatus =
	(statuses = validStatuses) =>
	(status) =>
		statuses.indexOf(status) !== -1;
